<script lang="ts">
export default {
  name: 'KkSiteIcon',
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import imgSiteGnaviPath from '../../../../../images/common/site_gnavi.png'
import imgSiteGooglePath from '../../../../../images/common/site_google.png'
import imgSiteHotPepperBeautyPath from '../../../../../images/common/site_hot_pepper_beauty.png'
import imgSiteHotPepperGourmetPath from '../../../../../images/common/site_hot_pepper_gourmet.png'
import imgSiteRettyPath from '../../../../../images/common/site_retty.png'
import imgSiteTabelogPath from '../../../../../images/common/site_tabelog.png'
import imgSiteTripAdvisorPath from '../../../../../images/common/site_trip_advisor.png'
import imgSiteAsoviewPath from '../../../../../images/common/site_asoview.png'
import imgSiteDemaecanPath from '../../../../../images/common/site_demaecan.png'
import imgSiteIkyuPath from '../../../../../images/common/site_ikyu.png'
import imgSiteOzmallPath from '../../../../../images/common/site_ozmall.png'
import imgSiteTribeauPath from '../../../../../images/common/site_tribeau.png'
import imgSiteReportClinicPath from '../../../../../images/common/site_report_clinic.png'
import imgSiteDocomoPath from '../../../../../images/common/docomo.png'
import imgSiteShufooPath from '../../../../../images/common/shufoo.png'
import imgSiteMapionBizPath from '../../../../../images/common/mapion_biz.png'
import imgSiteTaishuTenpyoPath from '../../../../../images/common/site_taishu_tenpyo.png'
import imgSiteYahooPath from '../../../../../images/common/yahoo.png'

/** Props */
type Props = {
  name: string
}
const props = defineProps<Props>()

/** Computed */
const imgPath = computed<string>(() => {
  switch( props.name ) {
  case 'gnavi':
    return imgSiteGnaviPath
  case 'google':
    return imgSiteGooglePath
  case 'google_map':
    return imgSiteGooglePath
  case 'hot_pepper_beauty':
    return imgSiteHotPepperBeautyPath
  case 'hot_pepper_gourmet':
    return imgSiteHotPepperGourmetPath
  case 'retty':
    return imgSiteRettyPath
  case 'tabelog':
    return imgSiteTabelogPath
  case 'trip_advisor':
    return imgSiteTripAdvisorPath
  case 'asoview':
    return imgSiteAsoviewPath
  case 'demaecan':
    return imgSiteDemaecanPath
  case 'ikyu':
    return imgSiteIkyuPath
  case 'ozmall':
    return imgSiteOzmallPath
  case 'tribeau':
    return imgSiteTribeauPath
  case 'report_clinic':
    return imgSiteReportClinicPath
  case 'docomo':
    return imgSiteDocomoPath
  case 'shufoo':
    return imgSiteShufooPath
  case 'mapion_biz':
    return imgSiteMapionBizPath
  case 'taishu_tenpyo':
    return imgSiteTaishuTenpyoPath
  case 'yahoo_loco':
  case 'yahoo_place':
  case 'yahoo_map':
    return imgSiteYahooPath
  default:
    return ''
  }
})
</script>

<template>
  <img :src="imgPath" alt="" class="siteIcon">
</template>

<style lang="scss" scoped>
.siteIcon {
  width: 100%;
}
</style>
